<template>
  <div class="container">
  
    <div class="title-box">
      <div class="title-en">GRADING RULES</div>
      <div class="title-zh">評選辦法</div>
    </div>

    <div class="content-box">
      <div class="table table1">
        <div class="table-title">國際組</div>
        <div class="content">
          <li>參賽企業營運狀況及經營願景</li>
          <li>參賽企業的商業模式及價值主張 / 營運方針或計畫</li>
          <li>參賽企業的產品／服務是否具有特殊國際競爭力</li>
          <li>參賽企業所提交海外拓展計劃的可行性</li>
          <div class="button">
            <a
              href="./2025國際組報名表.docx"
              download="2025國際組報名表.docx"
              class="table-download"
              target="_blank"
              >報名表下載</a
            >
          </div>
        </div>
      </div>

      <div class="table table2">
        <div class="table-title">永續組</div>
        <div class="content">
          <li>參賽企業營運狀況及經營願景</li>
          <li>參賽企業針對永續經營商業模式或環境永續的主張</li>
          <li>參賽企業是否開創符合經營永續或環保永續精神之嶄新商業模式</li>
          <li>
            參賽企業對其服務或產品在環保、能源管理或循環經濟等領域，是否有具體目標與作法
          </li>

          <!-- <div class="hint">※ 加分項目(永續組)：</div>

          <li>是否曾獲得環境永續相關標章或獎項</li>
          <li>過去一年是否因應環境氣候變遷風險而衍生新的業務或營收項目</li>
          <li>
            過去一年是否採用綠能或有具體省水、節電、減少排碳/溫室氣體等措施
          </li> -->
          <div class="button">
            <a
              href="./2025永續組報名表.docx"
              download="2025永續組報名表.docx"
              class="table-download"
              target="_blank"
              >報名表下載</a
            >
          </div>
        </div>
      </div>
    </div>

    <img
      class="gradin-bg1"
      src="../assets/images/2025/p7_img2@2x.webp"
      alt="grading_bg1"
      srcset=""
      
    />
  </div>
</template>

<script>
export default {
  name: "GradingRules",
  data() {
    return {
      isMobile: true,
    };
  },

  mounted() {
    this.onResize();

    window.addEventListener("resize", this.onResize, { passive: true });
  },

  methods: {
    onResize() {
      this.isMobile = window.innerWidth <= 1024;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_mixin.scss";
.container {
  width: 100%;
  position: relative;
  display: flex;
  margin-top: 8vw;
  // overflow: hidden;
  @media all and (max-width: 1024px) {
    flex-direction: column;
    margin-top: 12vw;
    margin-bottom: 28vw;
  }

  .grading-bg1-moblie {
    position: absolute;
    z-index: 0;
    width: 55%;
    top: -14vw;
  }
  .title-box {
    display: flex;
    width: 25%;
    justify-content: center;

    @media all and (max-width: 1024px) {
      width: 85%;
      flex-direction: column;
      margin: 0 auto;
      text-align: center;
      margin-bottom: 10vw;
      z-index: 2;
    }

    .title-zh {
      @include titleZH();
      @media all and (max-width: 1024px) {
        justify-content: center;
        text-align: center;
        display: flex;
      }
      &::after {
        @include titleAfter();
        height: 7vw;

        @media all and (max-width: 1920px) {
          height: 9vw;
        }

        @media all and (max-width: 1024px) {
          display: none;
        }
      }

      &::before {
        content: "";
        width: 24vw;
        display: none;
        margin-right: 6vw;
        border-top: 1px solid #fff;
        align-self: center;
        @media all and (max-width: 1024px) {
          display: inline-block;
        }
      }
    }

    .title-en {
      @include titleEN();

      @media all and (max-width: 1024px) {
        text-align: center;
      }
    }
  }
  .content-box {
    display: flex;
    width: 50%;
    justify-content: center;
    gap: 0.8%;
    z-index: 2;
    @media all and (max-width: 1024px) {
      width: 85%;
      flex-direction: column;
      margin: 0 auto;
    }
    .table {
      width: 49%;
      display: flex;
      flex-direction: column;
      @media all and (max-width: 1024px) {
        width: 100%;
      }
      .table-title {
        letter-spacing: 0.15em;
        background: url(data:image/webp;base64,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);
        background-size: cover;
        background-position-x: 50%;
        text-align: center;
        line-height: 3.4vw;
        border-radius: 0.5vw 0.5vw 0px 0px;
        margin-bottom: 0.3vw;
        @include subTitle();

        @media all and (max-width: 1024px) {
          font-size: 20px;
          line-height: 10vw;
          border-radius: 1.5vw 1.5vw 0px 0px;
          margin-bottom: 1vw;
        }
      }

      .content {
        background-image: url(../assets/images/2025/grading_table_bg@2x.webp);
        background-size: cover;
        padding-top: 1.5vw;
        padding-left: 1vw;
        padding-right: 1vw;
        height: 25vw;
        position: relative;
        border-radius: 0px 0px 0.5vw 0.5vw;

        @media all and (max-width: 1920px) {
          height: 30vw;
        }
        @media all and (max-width: 1440px) {
          height: 38vw;
        }

        @media all and (max-width: 1024px) {
          border-radius: 0px 0px 1.5vw 1.5vw;
          padding: 3vw 4vw;
          height: 100%;
          // background-image: none;
        }
        li {
          display: list-item;
          list-style: disc outside none;
          margin-left: 1vw;
          text-indent: -1.1vw;
          @include content();

          @media all and (max-width: 1024px) {
            margin-left: 6vw;
            text-indent: -5.9vw;
          }
        }

        .button {
          display: flex;
          justify-content: center;
          position: absolute;
          bottom: 2vw;
          left: 8.5vw;
          .table-download {
            background: linear-gradient(135deg, #e8d9ad 0%,#cab586 18%,#fdf4c8 50%,#c1a779 77%,#664f28 100%);
            @include buttonText();
            padding: 0.4vw 1vw;
            border: none;
            border-radius: 0.3vw;
            cursor: pointer;
            @media all and (max-width: 1024px) {
              border-radius: 1vw;
              padding: 2vw 4vw;
            }
          }

          @media all and (max-width: 1024px) {
            position: relative;
            bottom: 0vw;
            left: 0vw;
            margin-top: 5vw;
            margin-bottom: 3vw;
          }
        }
      }

      .hint {
        color: #fbf1b9;
        @include pt16Text();
        font-weight: bold;
        letter-spacing: 0.1em;
        margin: 0.7vw 0vw;
        margin-top: 1.5vw;
        @media all and (max-width: 1024px) {
          font-size: 3.7vw;
          margin-top: 5vw;
          margin-bottom: 2.5vw;
        }
      }
    }

    .table2 {
      @media all and (max-width: 1024px) {
        margin-top: 8vw;
      }
      .content {
        background-image: url(../assets/images/2025/grading_table_bg1.webp);
        background-size: cover;
      }
    }
  }
  .gradin-bg1 {
    position: absolute;
    right: -1%;
    bottom: -49%;
    width: 56%;

    @media (max-width: 1024px) {
      left: -36%;
      right: auto;
      bottom: -27%;
      width: 136%;
    }

    @media (max-width: 550px) {
      bottom: -20%;
    }
  }
}
</style>
